export default require('uuid/v4')